"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MosServiceScope = exports.MosServiceEndpoint = void 0;
exports.MosServiceEndpoint = "https://titles.prod.mos.microsoft.com";
exports.MosServiceScope = "https://titles.prod.mos.microsoft.com/.default";
//# sourceMappingURL=serviceConstant.js.map